import {useEffect, useState} from 'react';
import {AxiosError} from "axios";

interface UserInfo {
    name: string;
}

export default function useTeamsBinding({
                                            state,
                                            getUserInfo,
                                            getBindingStatus,
                                            bindingTeams,
                                            getToken,
                                        }: {
    state: string | null,
    getUserInfo: () => UserInfo
    getBindingStatus: () => Promise<boolean>
    bindingTeams: (uuid: string) => Promise<void>,
    getToken: () => string
}) {
    const [username, setUsername] = useState<string>("");
    const [isBound, setIsBound] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const token = getToken()
        if (!token) {
            handleRedirectToLogin();
            return
        }
        const userInfo = getUserInfo();
        setUsername(userInfo.name);
        checkBindingStatus();
        // eslint-disable-next-line
    }, []);

    async function checkBindingStatus() {
        setLoading(true);
        try {
            const status = await getBindingStatus();
            setIsBound(status);
        } catch (e) {
            setIsBound(false);
        } finally {
            setLoading(false);
        }
    }

    async function handleBind() {
        // const state = new URLSearchParams(window.location.search).get('state');
        if (!state) {
            return
        }
        try {
            await bindingTeams(state);

            window.alert("綁定成功");
            window.close();
        } catch (error) {
            // if error type is AxiosError
            if (error instanceof AxiosError) {
                const axiosError = error as AxiosError;
                const data = axiosError.response?.data as string;
                window.alert("綁定失敗,請重新嘗試，或是聯繫管理員\n" + data);
            } else {
                window.alert("綁定失敗,請重新嘗試，或是聯繫管理員");
            }
        }
    }

    function handleRedirectToLogin() {
        const tenantId = sessionStorage.getItem("tenant_id") || "";
        const loginUrl =
            process.env.REACT_APP_LOGIN_URL +
            "/login?tenantId=" +
            tenantId +
            "&redirectUri=" +
            window.location.href;
        window.location.replace(loginUrl);
    }

    function logout() {
        window.alert('您已登出')
        const tenantId = sessionStorage.getItem("tenant_id") || "";
        const logoutUrl =
            process.env.REACT_APP_LOGIN_URL +
            "/logout?tenantId=" +
            tenantId +
            "&redirectUri=" +
            window.location.href;
        sessionStorage.clear();
        window.location.replace(logoutUrl);
    }

    function handleClose() {
        window.close();
    }

    return {
        username,
        isBound,
        loading,
        handleBind,
        logout,
        handleClose,
    }
}
